import '@angular/compiler';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

declare global {
  interface Window {
    __ELX_BOOTSTRAPPED__?: boolean;
  }
}

bootstrapApplication(AppComponent, appConfig)
  .then(() => {
    window.__ELX_BOOTSTRAPPED__ = true;

    // Clear one-time recovery guards after a successful boot.
    try {
      sessionStorage.removeItem('elx_bootstrap_recovery_attempted');
      sessionStorage.removeItem('elx_chunk_recovery_attempted');
    } catch {}
  })
  .catch(() => {});
